'use strict';

angular.module('amexReconciliationApp')
  .component('receiptDropdownButton', {
    templateUrl: 'scripts/views/directives/receipt-dropdown-button.html',
    bindings: {
      uploadSuccess: '@',
      uploadFailure: '@',
      receiptTooLarge: '@',
      transaction: '<'
    },
    controller: function (TransactionReceiptService,
                          TransactionSearchModel,
                          SelectedTransactionService,
                          ActiveTransactionModel,
                          ReceiptRepository,
                          ReceiptService,
                          toastr,
                          UserModel,
                          UploadingTransactionReceiptsModel,
                          SiteConfigModel,
                          $uibModal,
                          $scope) {
      var self = this;

      self.showButton = function() {
        return SiteConfigModel.transactionReceiptsEnabled();
      };

      self.uploadingDisabled = function () {
        var uploadingIsLocked = ReceiptService.receiptUploadingIsLocked();
        var onTransactionsListPage = !ActiveTransactionModel.hasActiveTransaction();
        var hasZeroSelectedTransactions = SelectedTransactionService.selectedTransactionsCount() < 1;

        var disableButton =
          uploadingIsLocked || (onTransactionsListPage && hasZeroSelectedTransactions);

        return disableButton;
      };

      self.openReceiptPool = function openReceiptPool() {
        var scopeWithTransactions = $scope.$new();
        scopeWithTransactions.transactions = transactions();

        $uibModal.open({
          template: '<unmatched-receipt-pool-modal transactions="transactions" close-modal-callback="$close()"></unmatched-receipt-pool-modal>',
          size: 'lg',
          scope: scopeWithTransactions
        });
      };

      self.attachReceipts = function attachReceipts(receipts) {
        if (receipts && receipts.length) {
          var currentlySelectedTransactions = _.clone(transactions());
          UploadingTransactionReceiptsModel.add(currentlySelectedTransactions);
          try {
            ReceiptRepository
              .upload(_.map(receipts,function(receipt) {return {file: receipt, details: {}};}))
              .then(function (receipts) {
                return matchReceiptsToTransaction(receipts, currentlySelectedTransactions);
              })
              .then(successCallback)
              .catch(errorCallback)
              .finally(function () {
                finishUpload(currentlySelectedTransactions);
              });
          } catch(error) {
            toastr.error(self.uploadFailure);
            UploadingTransactionReceiptsModel.remove(ActiveTransactionModel.activeTransaction());
          }
        }
      };

      self.validateReceipt = function(receipt) {
        if (receipt.size > 5242880) {
          toastr.error(receipt.name + ' ' + self.receiptTooLarge);
          return false;
        }
      };


      self.receiptUploading = function () {
        return UploadingTransactionReceiptsModel.anyReceiptsUploading();
      };

      self.getReceiptTooltip = function() {
        if (self.uploadingDisabled() && ReceiptService.receiptUploadingIsLocked()) {
          return 'transactions.ReceiptsLockedTooltip';
        }
      };

      function matchReceiptsToTransaction(receipts, transactions) {
        return TransactionReceiptService.matchReceiptsToTransactions(receipts, transactions);
      }

      function transactions() {
        if (ActiveTransactionModel.hasActiveTransaction()) {
          return [ActiveTransactionModel.activeTransaction()];
        } else {
          return SelectedTransactionService.selectedTransactions();
        }
      }

      function successCallback() {
        toastr.success(self.uploadSuccess);
      }

      function errorCallback(error) {
        toastr.error(error || self.uploadFailure);
      }

      function finishUpload(transactions) {
        UploadingTransactionReceiptsModel.remove(transactions);
      }
    }
  });





//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/receiptDropdownButton.js
// module id = 532
// module chunks = 0